import React, { useEffect } from "react";
import { Helmet } from "react-helmet";

export default function DynamicBrand({ config }) {
  const type = Number(localStorage.getItem("user_type") || 7);

  const userLabel =
    type === 0
      ? "God"
      : type === 1
      ? "Admin"
      : type === 2
      ? "Super"
      : type === 3
      ? "Master"
      : type === 4
      ? "User"
      : type === 5
      ? "Broker"
      : type === 6
      ? "SubBroker"
      : "";

  const title = `${userLabel} ${config.APP_NAME} – Trading Platform`;

  // Update document title dynamically
  useEffect(() => {
    document.title = title;
  }, [title]);

  // Update favicon dynamically
  useEffect(() => {
    const setFavicon = (href) => {
      let link = document.querySelector("link[rel*='icon']");
      if (!link) {
        link = document.createElement("link");
        link.rel = "icon";
        document.head.appendChild(link);
      }
      link.href = href;
    };
    setFavicon(config.ICO);
  }, [config.ICO]);

  // Update app icons (192x192 & 512x512)
  useEffect(() => {
    const updateAppleIcon = (sizes, href) => {
      let link = document.querySelector(`link[sizes='${sizes}']`);
      if (!link) {
        link = document.createElement("link");
        link.rel = "apple-touch-icon";
        link.sizes = sizes;
        document.head.appendChild(link);
      }
      link.href = href;
    };

    updateAppleIcon("192x192", config.LOGO192);
    updateAppleIcon("512x512", config.LOGO512);
  }, [config.LOGO192, config.LOGO512]);

  return (
    <Helmet>
      <meta
        name="description"
        content={`${config.APP_NAME} || Paper Trading App`}
      />
      <meta name="application-name" content={`${config.APP_NAME}`} />
      <meta name="apple-mobile-web-app-title" content={`${config.APP_NAME}`} />
      <link rel="icon" href={config.ICO} />
      <link rel="apple-touch-icon" sizes="192x192" href={config.LOGO192} />
      <link rel="apple-touch-icon" sizes="512x512" href={config.LOGO512} />
    </Helmet>
  );
}
